import React from "react";
import { ReactComponent as UserSvg } from "../../svgs/user.svg";
import { ReactComponent as StarSvg } from "../../svgs/star.svg";
import { ReactComponent as SpiralSvg } from "../../svgs/spiral.svg";
import ictHub from "../../images/kad ict.png";
import massChallenge from "../../images/mc masschallenge.png";
import kondo from "../../images/kando.png";
import subtract from "../../images/Subtract.png";
import urbanShelter from "../../images/urban shelter.png";
import rsi from "../../images/rsi.png";
import gdi from "../../images/gdi.svg";
import wateraid from "../../images/wateraid-tall.webp";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import auth from "../../api/auth";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { routes } from "../../helper/misc";

function Footer() {
  const navigate = useNavigate();
  const {
    handleSubmit,
    formState: { errors },
    register,
    reset,
  } = useForm({ defaultValues: { email: "" } });

  const onSubmit = async (info) => {
    try {
      const {
        data: { message },
      } = await auth.signupForNewsLetter(info);
      toast.success(message);
      reset();
    } catch (e) {
      toast.error(e?.response?.data?.error || "There was an error");
    }
  };

  return (
    <div className="bg-pw-blue">
      <section className="relative max-w-[1280px] px-4 md:px-10 mx-auto">
        <SpiralSvg className="absolute hidden md:block lg:block lg:top-12 right-0" />
        <div className="flex flex-col md:flex-row lg:flex-row md:items-center lg:justify-between pl-16 md:justify-between md:h-48 lg:h-64 text-white md:scale-95 lg:scale-[80%]">
          <h4 className="font-normal hidden md:block w-40 text-xl md:mr-5">
            We speak with our powerful statistics
          </h4>
          <div className="mt-48 md:mt-0 lg-mt-0">
            <h1 className="text-7xl md:text-3xl lg:text-7xl font-extrabold">
              10K
            </h1>
            <h2 className="flex text-3xl md:text-xl lg:mt-5 lg:text-3xl font-normal">
              <UserSvg className="self-center" />
              <span className="md:ml-1 lg:ml-4">Active Users</span>
            </h2>
          </div>
          <div className="mt-32 md:mt-0 lg-mt-0">
            <h1 className="text-7xl md:text-3xl font-extrabold">30K+</h1>
            <h2 className="flex text-3xl md:text-xl lg:mt-5 lg:text-3xl font-normal">
              <StarSvg className="self-center " />
              <span className="ml-4">5-Stars Reviews</span>
            </h2>
          </div>
          <div className="mt-32 md:mt-0 lg-mt-0">
            <h1 className="text-7xl md:text-3xl lg:text-7xl font-extrabold">
              $250K
            </h1>
            <h2 className="flex text-3xl md:text-xl lg:mt-5 lg:text-3xl font-normal">
              <StarSvg className="self-center " /> Transactions
            </h2>
          </div>
        </div>
      </section>
      <div className="mt-24 md:mt-16 flex flex-col flex-wrap md:flex-row lg:flex-row gap-10 items-center justify-around mx-0 md:mx-24 md:scale-95 lg:scale-[80%]">
        <img className="mb-32 h-[100px]" src={ictHub} alt="" />
        <img className="mb-32 h-[50px]" src={massChallenge} alt="" />
        <img className="mb-32 h-[100px]" src={kondo} alt="" />
        <img className="mb-32" src={subtract} alt="" />
        <img className="mb-32 h-[100px]" src={urbanShelter} alt="" />
        <img className="mb-32 h-[100px]" src={rsi} alt="" />
        <img className="mb-32 h-[100px]" src={gdi} alt="" />
        <div className="mb-32 h-[120px] w-[120px] bg-white rounded-full flex items-center justify-center">
          <img className="h-[100px]" src={wateraid} alt="" />
        </div>
      </div>
      <div className="bg-gray-100 md:bg-white lg:bg-white pl-6">
        <div className="max-w-[1280px] px-4 md:px-10 mx-auto">
          <div className="text-left mx-auto md:w-[350px] lg:w-[500px]">
            <h2 className="pt-16 md:mt-0 font-bold text-2xl text-[#181433]">
              Join Our Newsletter
            </h2>
            <div className="mt-8">
              <input
                placeholder="Your email address"
                type="email"
                className={classNames(
                  "outline-0 bg-[#EEEEFF] pr-2 py-3 border-transparent transition-all duration-150 border hover:border-pw-blue hover:border-r-0 pl-2",
                  {
                    "!border-red": !!errors.email,
                  }
                )}
                {...register("email", { required: true })}
              />
              <button
                onClick={handleSubmit(onSubmit)}
                className="bg-pw-blue  border-pw-blue box-border text-white pl-4 font-medium py-3 md:pl-14 pr-10"
              >
                Subscribe
              </button>
              <p className="font-medium md:w-[350px] text-base md:text-xl text-[#181433] mt-[37px] lg:w-[450px]">
                * You'll receive weekly reports to assist with your water
                conservation efforts.
              </p>
            </div>
          </div>
          <div className="pt-32">
            <hr className="w-[95%] mx-auto" />
            <div className="flex items-center px-8 justify-between">
              <h4 className="my-10 px-3 font-medium text-base text-center text-[#181433]">
                Copyright @ PayWater 2022. All Rights Reserved.
              </h4>
              <button
                className="cursor-pointer"
                onClick={() => navigate(routes.privacy_policy)}
              >
                Privacy Policy
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
